<template>
    <main id="modal" class="abs flexContainer">
        <div id="dpi"></div>
        <section class="export-pdf rel">
            <section class="main-content-pages">
                <div id="content-title">
                    <div id="spinnerLoader" class="flexContainer abs" v-if="loading">
                        <Spinner :animation-duration="5000" :size="60" :color="'#41b4e8'" class="loader"></Spinner>
                    </div>
                    <div id="logoBrand"><img :src="getLogoBrand()" width="80" alt="logo brand" /></div>
                    <h2>{{ getPlanoDetails.campaign.name }}</h2>
                    <h3>{{ getPlanoDetails.name }}</h3>
                </div>
                <div class="content-pages flexContainer scrollX" v-if="preview">
                    <div class="page rel" v-for="n in nbPage" :key="n">
                        <div :id="'page-' + n" class="content-page rel">
                            <header>
                                <!-- <div v-for="n in getPlanoDetails"> -->
                                <div id="infosMain">
                                    <h3 class="uppercase title-page">{{ $t("exportPdfPlano.iconLayout") }} {{ n }} / {{ nbPage }}</h3>
                                </div>
                                <!-- </div> -->
                            </header>
                            <main id="pdfContent"></main>
                            <!-- <footer></footer> -->
                            <footer class="content-selected-page">
                                <input :id="'checkbox-' + n" type="checkbox" :value="n" v-model="selectedPages" />
                                <label class="ff-medium" :for="'checkbox-' + n">{{ $t("exportPdfPlano.page") }} {{ n }}</label>
                            </footer>
                        </div>
                    </div>
                </div>
            </section>
            <footer id="exportFooter" class="flexContainer jc-fe" v-if="preview">
                <button @click="exportXls" class="btnExp pointer">{{ $t("exportPdfPlano.exportXls") }}</button>
                <button @click="exportPdf" class="btnExp pointer">{{ $t("exportPdfPlano.export") }}</button>
                <button @click="closeWindow" class="btnExp pointer">{{ $t("exportPdfPlano.close") }}</button>
            </footer>
        </section>
    </main>
</template>
<style lang="scss">
#dpi {
    height: 1in;
    left: -100%;
    position: absolute;
    top: -100%;
    width: 1in;
}

#modal {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    z-index: 30;
    margin: auto;
}

.main-content-pages {
    padding: 5px;
}

.content-pages {
    height: 400px;
}

.content-selected-page {
    text-align: center;
    /*top: 560px;*/
    width: 300px;
    padding-top: 5px;
    label {
        font-size: 1.4rem;
    }
}

.export-pdf {
    background: #fff;
    padding: 30px; //   position: absolute;
    z-index: 200;
    width: 1000px;
    height: 100%;
    max-height: 610px;
    overflow-y: auto;
    //   top: 0px;
    //   left: 0px;
    //   padding: 5px;
    border-radius: 3px;
    margin: auto;
}

.content-pages {
    .content-page {
        padding: 5px;

        .title-page {
            text-align: center;
        }
    }
}

//   .page {
//       flex: 1;
//       height: 100%;
//   }
#exportFooter {
    margin-top: 20px;
    button {
        &:last-child {
            margin-left: 15px;
        }
    }
}

.page {
    #pdfContent {
        width: 250px;
        height: 300px;
        /*margin-right: 50px;*/
        /*table {*/
        /*transform: scale(0.2);*/
        /*transform-origin: 0 0;*/
        /*}*/
    }
    &:last-child {
        #pdfContent {
            margin-right: 0;
        }
    }
}

td {
    position: relative;
}

td img {
    max-width: 100%;
    position: absolute;
    top: 0;
    left: 0;
}

#spinnerLoader {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    top: 0;
    left: 0;
    border-radius: 3px;
    .loader {
        margin: auto;
    }
}

#spinnerLoader {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.7);
    z-index: 10;
    top: 0;
    left: 0;
    border-radius: 3px;
    .loader {
        margin: auto;
    }
}

svg {
    text,
    & tspan {
        width: 100% !important;
        font-family: "Oswald", sans-serif !important;
        /*font-size: 30px !important;*/
        text-transform: uppercase;
    }
    .textDIAM,
    .textclient {
        /*font-size: 22px !important;*/
    }
}
</style>
<script>
import { stateMixin } from "./mixins/state";
import { i18n } from "../../main";

const d3 = require("d3");
//    import { builderMixin } from './../mixins/builder'
import Vuex from "vuex";
import httpService from "../service";
import Globals from "../globals";
import Spinner from "vue-simple-spinner";
import { planoMixin } from "./mixins/plano";

export default {
    mixins: [stateMixin, planoMixin],
    props: {
        modules: Array,
        accessories: Array,
        hideFrame: { default: false, type: Boolean },
        preview: { default: true, type: Boolean },
        compression: String
    },
    data() {
        return {
            pdf: 0,
            nbCol: 0,
            nbPage: 0,
            selectedPages: [],
            loading: false,
            accessoriesSeg: [],
            accessoriesFrame: []
        };
    },
    components: {
        Spinner
    },
    computed: {
        ...Vuex.mapGetters({
            getPlanoDetails: "plano/data/getPlanoDetails",
            getDisplayMode: "plano/status/getDisplayMode"
        })
    },
    created() {
        this.loading = true;
        this.getLogoBrand();
        let datas = [];
        let data;
        let dataCopy;
        this.modules.forEach(module => {
            data = d3.select(module).data()[0];
            dataCopy = this.assign(data);
            dataCopy.svg = module;
            datas.push(dataCopy);
        });

        datas.sort((mod1, mod2) => {
            return mod1.posX - mod2.posX;
        });
        datas.sort((mod1, mod2) => {
            return mod1.posY - mod2.posY;
        });

        let accessoriesCopy = [];
        this.accessories.forEach(accessory => {
            accessoriesCopy.push(this.assign(accessory));
        });

        this.accessoriesSeg = accessoriesCopy.filter(accessory => {
            return accessory.subtype === "31";
        });

        this.accessoriesSeg.sort((accessory1, accessory2) => {
            return accessory1.posY - accessory2.posY;
        });

        this.accessoriesFrame = accessoriesCopy.filter(accessory => {
            return accessory.subtype === "40";
        });

        this.accessoriesFrame.sort((a1, a2) => {
            return a1.posX - a2.posX;
        });

        this.accessoriesFrame.sort((a1, a2) => {
            return a1.posY - a2.posY;
        });

        let blocks = this.getMeuble.plano ? this.getMeuble.plano.blocks : this.getMeuble.blocks;
        let rect = this.getRectByPosition(0, 0);
        let dataRect = d3.select(rect).data()[0];
        let bbContentPlanoMod = d3
            .select("#meubleInt")
            .node()
            .getBBox();
        let widthBlock = blocks[0] ? blocks[0].length : bbContentPlanoMod.width;
        let nbCol = widthBlock / dataRect.width;
        this.nbCol = nbCol;
        let nbBlock = Math.ceil(bbContentPlanoMod.width / widthBlock);
        // console.log(bbContentPlanoMod.width, widthBlock)

        // console.log(bbContentPlanoMod.width / widthBlock, nbBlock)
        this.nbPage = nbBlock;
        let posEndBlock = 0;
        let posStartBlock;
        let pdfTmp = [];
        let pageTmp;

        let planoWidthTmp = bbContentPlanoMod.width;
        let nbColReal = 0;
        for (let i = 1; i <= nbBlock; i++) {
            planoWidthTmp = planoWidthTmp - widthBlock;
            if (planoWidthTmp < 0) {
                nbColReal = Math.floor((widthBlock + planoWidthTmp) / dataRect.width);
            } else {
                nbColReal = nbCol;
            }
            // console.log(nbColReal, '=======')
            pageTmp = {
                modules: [],
                accessories: [],
                accessoriesFrame: [],
                nbCol: nbColReal
            };
            posEndBlock += nbColReal;
            for (let j = 0; j < nbColReal; j++) {
                // posEndBlock = i === 0 ? nbColReal : nbColReal * i
                posStartBlock = posEndBlock - nbColReal;
                datas.forEach(d => {
                    // console.log(posStartBlock, posEndBlock, nbColReal, d.posX)
                    if (d.posX >= posStartBlock && d.posX < posEndBlock) {
                        if (pageTmp.modules.includes(d) === false) {
                            pageTmp.modules.push(d);
                        }
                    }
                });

                this.accessoriesFrame.forEach(accessFrame => {
                    if (accessFrame.posX >= posStartBlock && accessFrame.posX < posEndBlock) {
                        if (pageTmp.accessoriesFrame.includes(accessFrame) === false) {
                            pageTmp.accessoriesFrame.push(accessFrame);
                        }
                    }
                });

                this.accessoriesSeg.forEach(access => {
                    if (access.posX >= posStartBlock && access.posX < posEndBlock) {
                        if (pageTmp.accessories.includes(access) === false) {
                            pageTmp.accessories.push(access);
                        }
                    }
                });
            }
            pdfTmp.push(pageTmp);
        }
        let horiPitchRepeat = this.getMeuble.plano ? this.getMeuble.plano.steps[1].repeat : this.getMeuble.steps[1].repeat;
        let vertPitchRepeat = this.getMeuble.plano ? this.getMeuble.plano.steps[0].repeat : this.getMeuble.steps[0].repeat;
        this.level = vertPitchRepeat;
        let count;
        let countTotal = vertPitchRepeat * horiPitchRepeat;
        let rest = countTotal;
        let y = -1;
        let x = 0;
        let x2, y2;
        // let xSeg = 0
        let ySeg = 0;
        let xTmp = 0;
        let xTmp2 = 0;
        let pdf = [];
        let page = [];
        let accessSeg;
        let mod;
        let valid;
        let pos = {};
        let countSeg = 0;
        let mods = [];
        let accessoriesInclude = [];
        // console.log(pdfTmp, '==== 1===')
        pdfTmp.forEach(p => {
            page = {};
            // page.nbColReal
            // console.log(p, '===========================================')
            x2 = 0;
            y2 = -1;
            xTmp2 = 0;
            page.modules = [];
            page.modulesShade = [];
            page.accessories = [];
            page.accessoriesFrame = [];
            page.nbCol = p.nbCol;
            count = vertPitchRepeat * p.nbCol;
            // console.log(p.nbCol, count)
            for (let j = 0; j < p.nbCol; j++) {
                // xSeg = countSeg
                // validSeg = true
                for (let i = 0; i < p.accessories.length; i++) {
                    accessSeg = p.accessories[i];
                    if (this.includesPosition(this.getPosAccessory(accessSeg), { x: countSeg, y: ySeg })) {
                        if (page.accessories.includes(accessSeg) === false) page.accessories.push(accessSeg);
                        // validSeg = false
                        break;
                    }
                }
                // if (validSeg) {
                //     page.accessories.push({UUID: null, posX: xSeg, posY: ySeg})
                // }
                countSeg++;
            }

            y = -1;
            if (rest !== 0) {
                for (let i = 0; i < count; i++) {
                    valid = true;
                    //                        validAccessory = true
                    rest--;
                    if (x % page.nbCol === 0) {
                        y++;
                        y2++;
                        x = xTmp;
                        x2 = xTmp2;
                    }
                    pos.x = x;
                    pos.y = y;

                    for (let k = 0; k < p.modules.length; k++) {
                        mod = p.modules[k];
                        if (this.includesPosition(this.getPosModule(mod), pos)) {
                            if (!mods.includes(mod)) {
                                mod.x1 = x2;
                                mod.y1 = y2;
                                mods.push(mod);
                            }

                            page.modules.push(mod);
                            page.modulesShade.push(mod);
                            valid = false;
                            break;
                        }
                    }

                    if (valid) {
                        page.modulesShade.push({ svg: null, posX: x, posY: y, x1: x2, y1: y2 });
                    }

                    p.accessoriesFrame.forEach(accessory => {
                        if (this.includesPosition(this.getPosModule(accessory), pos)) {
                            if (!accessoriesInclude.includes(accessory)) {
                                accessory.x1 = x2;
                                accessory.y1 = y2;
                                accessoriesInclude.push(accessory);
                            }

                            page.accessoriesFrame.push(accessory);
                        }
                    });

                    x++;
                    x2++;
                }
                xTmp = x;
                xTmp2 = x2;
            }

            //                countSeg += nbCol
            pdf.push(page);
            this.selectedPages.push(pdf.length);
        });

        this.pdf = pdf;
    },
    mounted() {
        // console.log(this.preview, 'preview ====')
        if (Globals.isMobile()) {
            this.preview = false;
        }
        // console.log(this.preview, '===== preview ====')
        this.sleep(500).then(() => {
            this.createPdf(this.preview);
            if (this.preview) this.loading = false;
        });
    },
    methods: {
        exportXls() {
            this.loading = true;
            httpService.get("/plano/" + this.$route.params.id + "/export-excel").then(res => {
                //                    console.log(res, '======')sss
                this.loading = false;
                if (res.status === 400) {
                    alert(res.message);
                } else {
                    let url = Globals.getBaseUrl() + res.path;
                    window.open(url);
                }
            });
        },
        getAccessoryPosForPdf(posX, posY, type = "40") {
            let accessories = type === "31" ? this.accessoriesSeg : this.accessoriesFrame;
            let accessory;
            for (let i = 0; i < accessories.length; i++) {
                accessory = accessories[i];
                //                    console.log(accessory, posX, posY, accessory.posX === posX && accessory.posY === posY)
                if (accessory.posX === posX && accessory.posY === posY && type === accessory.subtype) {
                    return accessory;
                }
            }

            return null;
        },
        createEltAccessoryFrame(accessory, sizeCm, sizePx, inCm) {
            if (accessory !== null) {
                let height = inCm ? accessory.size.height * sizeCm.height : accessory.size.height * sizePx.height;
                let width = inCm ? accessory.size.width * sizeCm.width : accessory.size.width * sizePx.width;
                let frame = document.createElement("div");
                frame.style.position = "absolute";
                frame.style.height = height + (inCm ? "cm" : "px");
                frame.style.width = width + (inCm ? "cm" : "px");
                frame.style.borderStyle = "solid";
                frame.style.borderColor = accessory.color;
                frame.style.borderWidth = inCm ? "0.1cm" : "6px";
                frame.style.top = 0;
                frame.style.left = 0;
                frame.style.zIndex = 10;

                return frame;
            }

            return null;
        },
        createEltAccessorySegmentation(accessory, sizeCm, sizePx, inCm) {
            let height = inCm ? accessory.size.height * sizeCm.height : accessory.size.height * sizePx.height;
            let width = inCm ? accessory.size.width * sizeCm.width : accessory.size.width * sizePx.width;
            let segmentation = document.createElement("div");
            segmentation.style.height = height + (inCm ? "cm" : "px");
            segmentation.style.width = width + (inCm ? "cm" : "px");
            segmentation.style.backgroundColor = "#1a1a1a";
            if (accessory !== null) {
                let fontSizeCm = this.getPixelToCm(30) + "cm";
                segmentation.style.height = height + (inCm ? "cm" : "px");
                segmentation.style.width = width + (inCm ? "cm" : "px");
                segmentation.style.color = "#FFF";
                segmentation.style.fontSize = inCm ? fontSizeCm : "35px";
                segmentation.style.backgroundColor = accessory.color;
                segmentation.style.textAlign = "center";
                segmentation.style.display = "inline-block";
                segmentation.style.padding = 0;
                segmentation.style.margin = 0;
                if (inCm) segmentation.style.marginBottom = this.getPixelToCm(5) + "cm";
                // let text = accessory.text ? this.getTranslate(accessory.text).trim().toUpperCase() : ''
                // console.log(text)
                segmentation.appendChild(document.createTextNode(this.getTranslate(accessory.text).toUpperCase()));
            }
            return segmentation;
        },
        calculRatio(width, height, widthPage, heightPage) {
            let heightChild = parseInt(height, 10);
            let widthChild = parseInt(width, 10);

            let ratioH = heightPage / heightChild;
            let ratioW = widthPage / widthChild;
            let ratio = 0;
            if (widthChild === heightChild) {
                if (ratioH < ratioW) {
                    ratio = ratioH;
                } else {
                    ratio = ratioW;
                }
            } else if (widthChild < heightChild) {
                ratio = ratioH;
            } else {
                ratio = ratioW;
            }
            return ratio;
        },
        getDPI() {
            return parseInt(document.getElementById("dpi").offsetHeight, 10);
        },
        getPixelToCm(pixel) {
            let cm = (2.54 * pixel) / this.getDPI();
            return cm;
        },
        getSizePageA4() {
            let heightHead = 29.7 * 0.2;
            let heightBody = 29.7 - heightHead;
            let widthMax = 21;
            let heightMax = heightBody;
            return { width: widthMax, height: heightMax };
        },
        getSizeComponentCm(width, height, ratio) {
            let widthModCm = this.getPixelToCm(width) * ratio;
            let heightModCm = this.getPixelToCm(height) * ratio;
            return { width: widthModCm, height: heightModCm };
        },
        exportPdf() {
            this.createPdf();
        },
        closeWindow() {
            this.$parent.displayViewPdf = false;
        },
        createTableInfo(page, sizeCm, ratio) {
            // console.log(page)
            let visuals = {
                blue: "#b2c9fe",
                red: "#ffb2c0",
                purple: "#dabcd7",
                yellow: "#fffdcc",
                green: "#b2d7be"
            };
            let row, cell, cellMain, contentTitle, contentInfo, config, groups, texts, contentShades;
            let refDiam, refClient, name, refColor, nameColor;
            let table = document.createElement("table");
            table.style.margin = "auto";
            let fontSize = this.getPixelToCm(12) * ratio;
            let fontSizeUl = this.getPixelToCm(14) * ratio;
            let paddingUl = this.getPixelToCm(3) * ratio;
            let borderContentInfo = this.getPixelToCm(2) * ratio;
            // console.log(page, '==============================================')
            // elt.appendChild(document.createTextNode(text))
            let j = 1;
            let k = 0;
            let letters = ["A", "B", "C", "D", "E", "F", "G", "H"];
            let letter;
            // console.log(page.modules)
            page.modulesShade.forEach((mod, i) => {
                if (i % page.nbCol === 0) {
                    k = 0;
                    row = table.insertRow();
                    cellMain = row.insertCell();
                    cellMain.appendChild(document.createTextNode(j));
                    j++;
                }
                cell = row.insertCell();
                cell.style.backgroundColor = mod.visual ? visuals[mod.visual] : "#eeecec";
                cell.style.verticalAlign = "top";
                cell.style.fontSize = fontSize + "cm";
                cell.style.height = sizeCm.height + "cm";
                cell.style.width = sizeCm.width + "cm";
                cell.style.maxHeight = sizeCm.height + "cm";
                cell.style.maxWidth = sizeCm.width + "cm";
                cell.style.overflow = "hidden";
                cell.style.border = "solid #FFFFFF " + borderContentInfo + "cm";
                // cell.style.overflow = 'hidden'

                contentInfo = document.createElement("div");
                // contentInfo.style.height = '100%'
                cell.appendChild(contentInfo);

                contentTitle = document.createElement("div");
                contentTitle.style.fontWeight = "bold";
                // contentTitle.style.whiteSpace = 'nowrap'
                // contentTitle.style.margin = paddingUl + 'cm'
                contentTitle.style.fontFamily = "'Oswald', sans-serif";
                // contentTitle.appendChild(document.createTextNode())

                contentInfo.appendChild(contentTitle);
                config = mod.config;
                if (config) {
                    texts = config.texts;
                    if (texts) {
                        refClient = Globals.getValueObject(texts, "refs.client", "");
                        refDiam = Globals.getValueObject(texts, "refs.DIAM", "");
                        name = Globals.getTranslate(texts.name);
                        letter = letters[k];
                        contentTitle.appendChild(document.createTextNode(letter + " - "));
                        contentTitle.appendChild(document.createTextNode(refDiam));
                        contentTitle.appendChild(document.createElement("br"));
                        contentTitle.appendChild(document.createTextNode(refClient));
                        contentTitle.appendChild(document.createElement("br"));
                        contentTitle.appendChild(document.createTextNode(name));
                        k++;
                    }

                    contentShades = document.createElement("ul");
                    contentShades.style.padding = paddingUl + "cm";
                    contentShades.style.listStyle = "none";
                    contentShades.style.fontSize = fontSizeUl + "cm";
                    contentShades.style.fontWeight = "none";
                    // contentShades.style.border = 'solid #FFFFFF ' + (this.getPixelToCm(1) * ratio) + 'px'

                    contentInfo.appendChild(contentShades);
                    groups = config.groups;
                    // console.log(groups, mod)

                    if (groups instanceof Array) {
                        groups.sort((g1, g2) => {
                            if (g1.position !== undefined && g2.position !== undefined) {
                                // console.log('new', mod.id)
                                return g1.position - g2.position;
                            } else {
                                let eltGr1 = document.querySelector("svg#" + mod.UUID + " g#" + g1.rowId);
                                let eltGr2 = document.querySelector("svg#" + mod.UUID + " g#" + g2.rowId);
                                // console.log(eltGr1.getBBox(), eltGr2.getBBox())
                                if (eltGr1 && eltGr2) {
                                    let bb1 = eltGr1.getBBox();
                                    let bb2 = eltGr2.getBBox();
                                    let res1 = bb1.x + bb1.y * 1000;
                                    let res2 = bb2.x + bb2.y * 1000;
                                    return res1 - res2;
                                } else {
                                    return 0;
                                }
                            }
                        });

                        // groups.sort((g1, g2) => {
                        //     let eltGr1 = document.querySelector('svg#pdf_' + mod.UUID + ' g#' + g1.rowId)
                        //     let eltGr2 = document.querySelector('svg#pdf_' + mod.UUID + ' g#' + g2.rowId)
                        //     // console.log(eltGr1.getBBox(), eltGr2.getBBox())
                        //     let bb1 = eltGr1.getBBox()
                        //     let bb2 = eltGr2.getBBox()
                        //     return bb1.x - bb2.x
                        // })

                        groups.forEach(group => {
                            // console.log(group)

                            if (group.color) {
                                refColor = Globals.getValueObject(group, "color.ref", "");
                                nameColor = Globals.getValueObject(group, "color.name", "");
                                if (refColor !== "" || nameColor !== "") {
                                    let li = document.createElement("li");
                                    li.style.whiteSpace = "nowrap";
                                    li.style.fontWeight = "none";
                                    li.style.fontFamily = "'Oswald', sans-serif";
                                    li.appendChild(document.createTextNode(refColor + " - " + nameColor));
                                    contentShades.appendChild(li);
                                }
                            }
                        });
                    }
                }
            });
            return table;
        },
        createPdf(view = false) {
            //  this.compression available
            let sizePageA4 = this.getSizePageA4();
            let pdf = this.pdf;
            let rect = this.getRectByPosition(0, 0);
            let dataRect = d3.select(rect).data()[0];
            let rectSeg = this.getRectSegmentationPosition(0, 0);
            let dataRectSeg = rectSeg ? d3.select(rectSeg).data()[0] : { width: 0, height: 0 };
            let heightForRatio =
                rectSeg === null
                    ? this.getPixelToCm(dataRect.height * this.level)
                    : this.getPixelToCm(dataRect.height * this.level + dataRectSeg.height);
            let ratio = this.calculRatio(this.getPixelToCm(dataRect.width * this.nbCol), heightForRatio, sizePageA4.width, sizePageA4.height);
            //                 let sizeSegCm = rectSeg !== null ? this.getSizeComponentCm(dataRectSeg.width, dataRectSeg.height, ratio) : null

            let sizeModCm = this.getSizeComponentCm(dataRect.width, dataRect.height, ratio);
            // let table, tHead, tBody
            // let cell
            // let row
            let content;
            // let nbCol = this.nbCol
            // let modsInclude = []
            // let accessoriesInclude = []
            // let cellNull
            let nbPage;
            let object = {
                level: 1,
                campaign: this.getPlanoDetails.campaign.name,
                pages: [],
                local: i18n.locale
            };
            let pageObject;
            // let svg
            let nbPageT = 0;
            // let accessory, eltAccessory, eltAccessorySeg
            let xmlns = "http://www.w3.org/2000/svg";
            let widthViewBox;
            // let heightViewBox = (nbCol * dataRect.height) + (dataRectSeg.height)
            let heightViewBox = this.level * dataRect.height + dataRectSeg.height;
            let svgPage;
            let svgMod;
            let modules;
            let x, y;
            let framesOut = [];
            let framesOutTmp = [];
            let frameOut;
            pdf.forEach((page, index) => {
                // console.log(page)
                nbPage = index + 1;
                x = 0;
                y = 0;
                // console.log(x, y)
                if (view || this.selectedPages.includes(nbPage)) {
                    nbPageT++;
                    svgPage = document.createElementNS(xmlns, "svg");
                    widthViewBox = page.nbCol * dataRect.width;
                    svgPage.setAttributeNS(null, "viewBox", "0 0 " + widthViewBox + " " + heightViewBox);
                    if (view) {
                        svgPage.setAttributeNS(null, "width", "100%");
                        svgPage.setAttributeNS(null, "height", "100%");
                    } else {
                        // let sizeSvg = this.getSizeComponentCm(widthViewBox, heightViewBox, ratio)
                        svgPage.setAttributeNS(null, "width", "95%");
                        svgPage.setAttributeNS(null, "height", "95%");
                        svgPage.setAttributeNS(null, "style", "margin: auto; display: block");
                    }
                    let svgPageD3 = d3.select(svgPage);
                    let xLine;
                    let yStartLine = 0;
                    let yEndLine = dataRect.height * this.level + dataRectSeg.height;

                    for (let j = 0; j <= page.nbCol; j++) {
                        xLine = j * dataRect.width;
                        svgPageD3
                            .append("line")
                            .attr("stroke", "#000000")
                            .attr("stroke-width", 1)
                            .attr("x1", xLine)
                            .attr("x2", xLine)
                            .attr("y1", yStartLine)
                            .attr("y2", yEndLine);
                    }

                    let yLine;
                    let xStartLine = 0;
                    let xEndLine = dataRect.width * page.nbCol;

                    for (let j = 0; j <= this.level; j++) {
                        yLine = j * dataRect.height + dataRectSeg.height;
                        svgPageD3
                            .append("line")
                            .attr("stroke", "#000000")
                            .attr("stroke-width", 1)
                            .attr("y1", yLine)
                            .attr("y2", yLine)
                            .attr("x1", xStartLine)
                            .attr("x2", xEndLine);
                    }

                    modules = page.modules;
                    if (rectSeg) {
                        svgPageD3
                            .append("rect")
                            .attr("x", 0)
                            .attr("y", 0)
                            .attr("height", dataRectSeg.height)
                            .attr("width", dataRectSeg.width * page.nbCol)
                            .attr("fill", "#000000");
                        page.accessories.forEach(accessory => {
                            // console.log(accessory)
                            let widthSeg = dataRectSeg.width * accessory.size.width;
                            let heightSeg = dataRectSeg.height * accessory.size.height;
                            svgPageD3
                                .append("rect")
                                .attr("x", 0)
                                .attr("y", 0)
                                .attr("height", dataRectSeg.height)
                                .attr("width", widthSeg)
                                .attr("fill", "#000000");

                            let name = this.getTranslate(accessory.text);
                            let fontSize = (dataRectSeg.height - 10) * accessory.size.height;
                            let size = (fontSize * name.length) / 4;
                            svgPageD3
                                .append("text")
                                .attr("x", widthSeg / 2 - size)
                                .attr("y", heightSeg - 5)
                                .attr("fill", "#FFFFFF")
                                .style("font-size", fontSize)
                                .text(name);
                        });
                    }
                    let modsInclude = [];
                    modules.forEach(mod => {
                        if (!modsInclude.includes(mod)) {
                            modsInclude.push(mod);
                            if (mod.svg) {
                                svgMod = mod.svg.cloneNode(true);
                                svgMod.id = "pdf_" + svgMod.id;
                                svgPage.appendChild(svgMod);
                                x = mod.x1 * dataRect.width;
                                y = mod.y1 * dataRect.height + dataRectSeg.height;
                                d3.select(svgMod)
                                    .attr("x", x)
                                    .attr("y", y);

                                if (this.$parent.realistic === true && mod.srcreal) {
                                    let urlReal = this.getCleanUrl(mod.srcreal);
                                    d3.select(svgPage)
                                        .append("svg:image")
                                        .raise()
                                        .attr("xlink:href", urlReal)
                                        .attr("x", x)
                                        .attr("y", y)
                                        .attr("width", dataRect.width * mod.size.width)
                                        .attr("height", dataRect.height * mod.size.height);
                                }
                            }
                        }
                    });

                    if (this.hideFrame === false) {
                        let accessFrame = [];
                        frameOut = null;
                        framesOutTmp = [];
                        page.accessoriesFrame.forEach(accessoryFrame => {
                            if (accessFrame.includes(accessoryFrame) === false) {
                                accessFrame.push(accessoryFrame);
                                // console.log(accessFrame)

                                let size = accessoryFrame.x1 + accessoryFrame.size.width;
                                // console.log(accessoryFrame, framesOut, size, page)
                                x = accessoryFrame.x1 * dataRect.width;
                                y = accessoryFrame.y1 * dataRect.height + dataRectSeg.height;

                                let rect = svgPageD3
                                    .append("rect")
                                    .raise()
                                    .attr("x", x)
                                    .attr("y", y)
                                    .attr("stroke", accessoryFrame.color)
                                    .attr("stroke-width", 8)
                                    .attr("fill-opacity", 0);
                                if (size > page.nbCol) {
                                    // console.log("==================================")
                                    let rest = size - page.nbCol;
                                    frameOut = {
                                        accessory: accessoryFrame,
                                        restWidth: rest
                                    };
                                    framesOutTmp.push(frameOut);
                                    let widthSize = accessoryFrame.size.width - rest;
                                    let width = dataRect.width * widthSize;
                                    let height = dataRect.height * accessoryFrame.size.height;
                                    // rect.attr('stroke-dasharray', "")
                                    let borderVisible = width;
                                    let borderVisible2 = width + height;
                                    let borderUnVisible = height;
                                    rect.attr("width", width);
                                    rect.attr("height", height);
                                    rect.attr("stroke-dasharray", borderVisible + ", " + borderUnVisible + ", " + borderVisible2);
                                    // framesOut.push()
                                } else {
                                    rect.attr("width", dataRect.width * accessoryFrame.size.width).attr(
                                        "height",
                                        dataRect.height * accessoryFrame.size.height
                                    );
                                }

                                //     .attr('x', 0)
                                //     .attr('y', 0)
                                //     .attr('height', dataRectSeg.height)
                                //     .attr('width', widthSeg)
                                //     .attr('fill', '#000000')
                            }
                        });
                        let validRest = false;
                        framesOut.forEach(frame => {
                            let accessory = frame.accessory;
                            // x = -((accessory.size.width - frame.restWidth) * dataRect.width)
                            x = 0;
                            y = accessory.y1 * dataRect.height + dataRectSeg.height;
                            let height = dataRect.height * accessory.size.height;
                            let width = dataRect.width * frame.restWidth;
                            let borderVisible = 2 * width + height;
                            let borderUnVisible = height;
                            svgPageD3
                                .append("rect")
                                .raise()
                                .attr("x", x)
                                .attr("y", y)
                                .attr("width", width)
                                .attr("height", height)
                                .attr("stroke", frame.accessory.color)
                                .attr("stroke-width", 5)
                                .attr("fill-opacity", 0)
                                .attr("stroke-dasharray", borderVisible + ", " + borderUnVisible);

                            // framesOut.splice(framesOut.indexOf(frame), 1)
                            validRest = true;
                        });

                        if (validRest) framesOut = [];
                        // if (validRest) {
                        //     framesOut.remove
                        // }
                        if (framesOutTmp.length > 0) {
                            // framesOut.push(frameOut)
                            framesOut = framesOutTmp;
                        }
                    }

                    // console.log(modules)

                    if (view) {
                        content = document.querySelector("#page-" + nbPage + " main");
                        content.appendChild(svgPage);
                    } else {
                        let tableInfo = this.createTableInfo(page, sizeModCm, ratio);
                        pageObject = {
                            content: svgPage,
                            contentInfo: tableInfo,
                            pager: nbPageT + "/" + this.selectedPages.length,
                            campaign: this.getPlanoDetails.campaign.name,
                            title: this.getPlanoDetails.name
                        };
                        object.pages.push(pageObject);
                    }
                }
            });
            if (view === false) {
                // todo exporter le html au serveur php
                object.level = this.level;
                object.step = this.nbCol;
                object.name = this.getPlanoDetails.name;
                object.compressLevel = this.compression;
                object.pages.forEach((page, i) => {
                    let texts = d3
                        .select(page.content)
                        .selectAll("svg")
                        .select("g#TICKET_STRIPS")
                        .selectAll("text");
                    // console.log(texts)
                    texts.each((d, i, cmps) => {
                        let cmp = cmps[i];
                        let y = parseInt(cmp.getAttribute("y"), 10) - 7.5;
                        cmp.setAttribute("y", y);
                    });

                    page.content = page.content.outerHTML;
                    page.contentInfo = page.contentInfo.outerHTML;
                    // console.log(page.contentInfo)
                    // console.log(page.contentInfo)
                });
                this.loading = true;
                httpService.post("/generate-svg-pdf", JSON.stringify(object)).then(response => {
                    let url = Globals.getBaseUrl() + response.url;
                    window.open(url);
                    this.loading = false;
                    // this.loading = false
                    if (Globals.isMobile() || !this.preview) this.closeWindow();
                });
            }
        }
    }
};
</script>



// WEBPACK FOOTER //
// ExportPdf.vue?49163f02